<template>
  <section>
    <div class="modal is-clipped" :class="{'is-active': toggleModal}">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Add iCal URL</p>
          <button class="delete" aria-label="close" @click="toggleModal=false" />
        </header>
        <section class="modal-card-body">
          <form class="addICSURL" @submit.prevent="addICSURL">
            <div class="content">Enter an iCal/ICS URL corresponding to your calendar.</div>
            <div class="field is-grouped is-grouped-centered">
              <input
                required
                autofocus
                class="input"
                type="url"
                placeholder="https://google.com/mycalendar.ics"
                pattern="https:\/\/.*\/*.ics"
                v-model="icsURL"
              />
            </div>
            <button class="button is-centered is-link">Add iCal URL</button>
            <p class="help is-danger" v-if="addICSURLError">{{statusMessage}}</p>
          </form>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
import EventBus from "../event-bus";

export default {
  name: "AddICSURL",
  data() {
    return {
      toggleModal: false,
      addICSURLError: false,
      icsURL: "",
      statusMessage: ""
    };
  },
  updated: function() {
    this.$parent.getCalendarUsers();
  },
  mounted: function() {
    EventBus.$on("displayAddICSURL", eventData => {
      this.toggleModal = eventData;
      this.addICSURLError = false;
      this.statusMessage = "";
      this.icsURL = "";
    });
  },
  methods: {
    addICSURL() {
      this.addICSURLError = false;
      this.statusMessage = "";
      let data = {
        ics_url: this.icsURL
      };
      this.$http
        .post(process.env.VUE_APP_API_URL + "/calendarsync", data)
        .then(function() {
          EventBus.$emit("displayAddICSURL", false);
        })
        .catch(httpError => {
          if (httpError.response) {
            switch (httpError.response.data.error) {
              case "Error saving ICS file" ||
                "Invalid MIME type" ||
                "Invalid ICS file":
                this.addICSURLError = true;
                this.statusMessage =
                  "Error adding iCal URL. Please contact support.";
                this.icsURL = "";
                break;
              case "Calendar user subscriptions exceeded":
                this.addICSURLError = true;
                this.statusMessage =
                  "Error adding iCal URL. You have exceeded the number of subscribed calendar users.";
                this.icsURL = "";
                break;
              case "Calendar user already exists":
                this.addICSURLError = true;
                this.statusMessage =
                  "Error adding iCal URL. Calendar user already exists.";
                this.icsURL = "";
                break;
            }
          }
        });
    }
  }
};
</script>
